export default __webpack_public_path__ + "static/media/loadingSpinner.7590c3dd.svg";